<form [formGroup]="form">
	<div class="employees-input">
		<label class="label" for="{{idPrefix + standard.toLowerCase()}}">{{ label }}</label>
		<input id="{{idPrefix + standard.toLowerCase()}}" type="number" nbInput placeholder="0" fullWidth
			   [formControlName]="fullControlName(controlName)" [attr.formcontrolname]="fullControlName(controlName)" [max]="isClientInput ? 1000000 : 2025"
			   (keypress)="preventNonNumericalInput($event)" [nbPopover]="numberExceedPopover"
			   nbPopoverPlacement="{{popoverPlacement}}" nbPopoverTrigger="noop" (change)="isClientInput && showPopoverIfNeeded($event)" (focusout)="isClientInput && hidePopover()"
			   (focus)="isClientInput && showPopover()" (keyup)="isClientInput ? showPopover() : preventMoreThanExpectedInput()"
			   [placeholder]="'company-general-info.employees-input-component.input-placeholder' | translate">
		@if (anyEmployeeControlInvalid()) {
			<div display-in-one-line="\(.+\)" class="validation-message">{{ getValidationErrors(controlName) | async }}</div>
		}
		@if (!isClientInput) {
			<div class="employees-count-hint">Max. number of employees should be 2025.</div>
		}
	</div>
</form>

<ng-template #numberExceedPopover>
	<div class="employee-number-exceed-popup">
		<span [innerHTML]="'company-general-info.employees-input-component.popup' | translate"></span>
		<span class="popover-contact">{{ 'company-general-info.employees-input-component.contact' | translate }}<br>
			{{ 'company-general-info.employees-input-component.phone' | translate }}
      </span>
	</div>
</ng-template>
